import { IUserBase } from '../../models/users';
import wbsBookingsApi from '../apis/wbsBookingsApi';

const createProfileConfirmationsService = async (
  userId: string,
): Promise<IUserBase> => {
  const { data } = await wbsBookingsApi.post<IUserBase>(
    `/users/${userId}/profile-confirmation`,
  );

  return data;
};

export default createProfileConfirmationsService;
